import styled, { css, keyframes } from "styled-components"
import { overloadColor } from "../../util/style"

const ellipsis1 = keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`
const ellipsis2 = (size: number) => keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(${size}px, 0);
  }
`
const ellipsis3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`

interface DotsEllipsisProps {
  color: string
  size: number
}
export const DotsEllipsis = styled.div<DotsEllipsisProps>`
  display: inline-block;
  position: relative;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;

  div {
    position: absolute;
    top: ${(props) => props.size * 0.4}px;
    width: ${(props) => props.size * 0.1625}px;
    height: ${(props) => props.size * 0.1625}px;
    border-radius: 50%;
    background: ${(props) => overloadColor(props.color)};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: ${(props) => props.size * 0.1}px;
    animation: ${ellipsis1} 0.6s infinite;
  }
  div:nth-child(2) {
    left: ${(props) => props.size * 0.1}px;
    animation: ${(props) => ellipsis2(props.size * 0.3)}${css`.6s`} infinite;
  }
  div:nth-child(3) {
    left: ${(props) => props.size * 0.4}px;
    animation: ${(props) => ellipsis2(props.size * 0.3)} 0.6s infinite;
  }
  div:nth-child(4) {
    left: ${(props) => props.size * 0.7}px;
    animation: ${ellipsis3} 0.6s infinite;
  }
`
